module.exports = __webpack_public_path__ + "img/graf_dm_blue.43e9cb68.svg";